"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.variantsLabels = void 0;
const ArticlesList_contracts_1 = require("./ArticlesList.contracts");
exports.variantsLabels = {
    [ArticlesList_contracts_1.ArticlesListVersion.Text]: 'forms.articleList.variantText',
    [ArticlesList_contracts_1.ArticlesListVersion.Thumbnails]: 'forms.articleList.variantThumbnails'
};
//# sourceMappingURL=ArticlesList.config.js.map